export default "__VITE_ASSET__Qe6v2ofG__"